'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      className={cn(
        'peer data-[state=checked]:bg-[#6366f1] data-[state=unchecked]:bg-[#f4f4f6] focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-6 w-[56px] shrink-0 items-center rounded-full border-0 p-[2.4px] transition-all outline-none focus-visible:ring-[3px] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={cn(
          'bg-white pointer-events-none block h-[19px] w-[31px] rounded-full ring-0 shadow-[0px_1.8px_7.2px_0px_rgba(0,0,0,0.08)] transition-transform data-[state=checked]:translate-x-[20px] data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
